var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHospital1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1646 1012L1646 1040",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1646.5,
    cy: 1007.33,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1645.08 1012.22H1647.92V1008.92H1651.22V1006.08H1647.92V1002.78H1645.08V1006.08H1641.78V1008.92H1645.08V1012.22ZM1639.89 1016C1639.37 1016 1638.92 1015.82 1638.55 1015.45C1638.18 1015.08 1638 1014.63 1638 1014.11V1000.89C1638 1000.37 1638.18 999.925 1638.55 999.555C1638.92 999.185 1639.37 999 1639.89 999H1653.11C1653.63 999 1654.08 999.185 1654.45 999.555C1654.82 999.925 1655 1000.37 1655 1000.89V1014.11C1655 1014.63 1654.82 1015.08 1654.45 1015.45C1654.08 1015.82 1653.63 1016 1653.11 1016H1639.89ZM1639.89 1014.11H1653.11V1000.89H1639.89V1014.11Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital1);
export default __webpack_public_path__ + "static/media/hospital_1.2c05d58c1431cba7e9bb1882783947a8.svg";
export { ForwardRef as ReactComponent };